import { render, staticRenderFns } from "./TagDetail.vue?vue&type=template&id=ed507ff8&scoped=true"
import script from "./TagDetail.vue?vue&type=script&lang=js"
export * from "./TagDetail.vue?vue&type=script&lang=js"
import style0 from "./TagDetail.vue?vue&type=style&index=0&id=ed507ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed507ff8",
  null
  
)

export default component.exports